// Navigation capabilities preserve existing supported workspaces. Server
// middleware remains authoritative for each operation and record.
export const WEB_ROLES = ['admin', 'specialist', 'pm', 'contracting_officer'] as const;
export const MOBILE_ROLES = ['salesman', 'estimator', 'foreman', 'designer'] as const;
export const canUseWeb = (role: string) => (WEB_ROLES as readonly string[]).includes(role);
export const isMobileRole = (role: string) => (MOBILE_ROLES as readonly string[]).includes(role);
export const canAccessGovernment = (role: string) => ['admin', 'contracting_officer'].includes(role);
export const isGovernmentOnlyRole = (role: string) => role === 'contracting_officer';
